import { VideoInteractionStatus, mapInteraction } from "./backendPayload";

export function buildUpdateInteractionPayload(interaction) {
  const backendInteraction = mapInteraction(interaction, interaction.id);
  if (!backendInteraction) return null;
  return {
    InteractionId: interaction.id,
    Interaction: JSON.stringify(backendInteraction),
    VideoInteractionType: backendInteraction.type,
    VideoInteractionStatus:VideoInteractionStatus.PendingReview,
    StartTime: Math.round(interaction.timeSec * 1000)
  };
}
